<template>
    <div class="app-wrap" :class="classObj">
        <navbar></navbar>
        <div class="main-container">
            <sidebar ref="mainSide" v-if="!hideRouter" class="sidebar-container" :opends="navDefaultOpends"></sidebar>
            <app-main ref="mainRoot" :hideBread="hideRouter"></app-main>
        </div>
        <footbar color="#b8b8b8" hover-color="#ffba15"></footbar>
        <div class="alert-info">
            <div class="show-alert-img" v-if="showAlertImg">
                <div class="content-wrap">
                    <span class="close" @click="showAlertImg = false;"><svg-icon class="ic_close" icon-class="ic_close" class-name="ic_close"></svg-icon></span>
                    <div @click="toDetail" class="image">
                      <img :src="alertInfoForm.img" alt="">
                    </div>
                    <!-- <img src="https://f12stag.kkmh.com/image/201110/zsTkGofyi-w640" alt=""> -->
                    <el-button type="primary" @click="toDetail">{{alertInfoForm.text}}</el-button>
                </div>
            </div>
            <el-dialog
                title=""
                :visible.sync="showAlertWord"
                append-to-body
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                width="30%"
                class="alert-dialog">
                <span>{{alertInfoForm.content}}</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="showAlertWord = false">关闭</el-button>
                    <el-button type="primary" @click="toDetail">{{alertInfoForm.text}}</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import { constantRouterMap } from '@/router'
import Footbar from '@/components/Footbar'
import { mapGetters } from 'vuex'

export default {
    name: 'layout',
    components: {
        Navbar,
        Sidebar,
        AppMain,
        Footbar
    },
    data() {
        return {
            routerComputed: false,
            navDefaultOpends: [],
            showAlertWord: false,
            showAlertImg: false,
            alertInfoForm: {
                img: '',
                content: '',
                jump_type: '',
                action: {}
            }
        }
    },
    computed: {
        ...mapGetters([
            'alertInfo',
            'permissionSecond',
            'permission',
            'uid'
		]),
        classObj() {
            return {
                withoutAnimation: this.sidebar.withoutAnimation,
                'only-container': this.hideRouter
            }
        },
        sidebar() {
            return this.$store.state.app.sidebar
        }
    },
    watch: {
        alertInfo(val) {
          if (val) {
            console.log('1', this.alertInfo)
            this.checkAlertShow()
          }
        },
        permission() {
          console.log('2', this.alertInfo)
          this.checkAlertShow()
        }
    },
    props: {
        hideRouter: {
			type: Boolean,
			default: false
		},
    },
    created() {
        // 检查登录
        this.checkLogin()
    },
    mounted() {
        // 页面main-wrap根节点元素(指针)
        this.$store.dispatch('setMainRoot', this.$refs.mainRoot.$el)
    },
    methods: {
        checkAlertShow() {
          const val = this.alertInfo
          if (!val || !val.jump_type) return
          this.alertInfoForm = {
              jump_type: val.jump_type,
              action: val.action_type_protocol,
              text: val.button_text || '去看看'
          }
          let show = false;
          // 判断权限，格式：导航name@大权限@小权限
          // 如果不需要判断权限则只有name
          // 导航使用导航name
          if (val.jump_type == 2) {
              let aTarget = this.alertInfoForm.action.target_id.split('@');
              if (aTarget.length == 2) {
                  // 只有一个权限控制
                  if (this.permission[aTarget[1]] && this.permission[aTarget[1]].navigation) {
                      show = true;
                  }
              } else if (aTarget.length == 3) {
                  // 大权限判断和小权限判断一起
                  if (this.permission[aTarget[1]] && this.permission[aTarget[1]].navigation && this.permissionSecond[aTarget[1]][aTarget[2]]) {
                      show = true;
                  }
              } else {
                  // 无权限
                  show = true;
              }
          } else {
              show = true;
          }
            // content-type: 1:文字 2:图片
            if (val.content_type == 1) {
                // this.showAlertWord = true;
                this.showAlertWord = show;
                this.alertInfoForm.content = val.content;
                /** 20220615 资源位埋点：弹窗-曝光 */ 
                this.sa('CCRePoEXP', '', val.content);
                return
            }
            this.alertInfoForm.img = val.content;
            this.showAlertImg = show;
            /** 20220615 资源位埋点：弹窗-曝光 */ 
            this.sa('CCRePoEXP', '', val.content);
        },
        toDetail() {
            this.showAlertImg = false;
            this.showAlertWord = false;
            /** 20220615 资源位埋点：弹窗-点击 */
            this.sa('CCRePoClK', '', this.alertInfo.content);
            // 创作活动
            if (this.alertInfoForm.jump_type == 1) {
                const url = '/activity/activity_detail/' + this.alertInfoForm.action.target_id;
                this.$router.push(url);
                return
            }
            // 导航tab
            if (this.alertInfoForm.jump_type == 2) {
                let aTarget = this.alertInfoForm.action.target_id.split('@');
                const name = aTarget[0] === 'opusviews' ? 'opusview' : aTarget[0];
                this.$router.push({
                    name: name
                });
                return
            }
            // 通用跳转
            let actionUrl = '';
            if (this.alertInfoForm.action.type == 2) {
                actionUrl = 'https://www.kuaikanmanhua.com/web/topic/' + this.alertInfoForm.action.target_id;
            } else if (this.alertInfoForm.action.type == 3) {
                actionUrl = 'https://www.kuaikanmanhua.com/web/comic/' + this.alertInfoForm.action.target_id;
            } else {
                actionUrl = this.alertInfoForm.action.target_web_url;
            }
            location.href = actionUrl;
        },
        checkLogin() {
            const token = this.$util.getCookie('passToken')
            const routeApply = res => {
                if (res && res.role == 0) {
                    this.$router.push({ path: '/applyauthor' })
                    return
                }
            }
            if (token) {
                // 验证成功
                if (!this.$store.state.user.uid) {
                    const name = this.$util.getCookie('name')
                    const face = this.$util.getCookie('face')
                    if (name && face) {
                        // 已登录情况下刷新
                        this.$store.dispatch('getUserInfo').then(res => {
                            routeApply.call(this, res)
                            this.$store.dispatch('setUserInfos', {
                                // uid: this.$util.getCookie('uid'),
                                // grade: this.$util.getCookie('grade'),
                                // name: name,
                                // face: face
                                uid: this.$util.getCookie('uid'),
                                grade: this.$util.getCookie('grade'),
                                name: res.nickname,
                                face: res.avatar_url,
                                role: res.role
                            })
                        }).catch(e => {
                            console.log(e)
                        })
                    } else {
                        // 从官网登录的用户 直接打开内页
                        this.$axios({
                            method: 'post',
                            url: '/v1/passport/login/pc/user_login_check',
                            custom: true
                        }).then(res => {
                            if (res.code == 200) {
                                const data = res.data.user
                                const object = {
                                    uid: data.uid || data.id,
                                    name: data.nickname,
                                    face: data.avatar_url,
                                    grade: data.grade
                                }
                                this.$store.dispatch('setUserInfos', object).then(res => {
                                    routeApply.call(this, res)
                                })
                            }
                            this.loading = false
                        })
                    }
                } else {
                    const grade = this.$util.getCookie('grade')
                    if (grade == 0) {
                        this.$store.dispatch('getUserInfo').then(res => {
                            routeApply.call(this, res)
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                }
                // 查询权限
                this.$store.dispatch('checkPermission').then((permission) => {
                    let opendsNav = []
                    let computedNav = constantRouterMap.slice()
                    this.$store.dispatch('computedNav', computedNav.filter(item => {
                        // 20210607新增一级目录节点meta.role参数，用于控制一级目录的权限显示，供/comic_video路径使用
                        if (item && item.meta && item.meta.role) {
                            const rootPermissionValue = permission[item.meta.role] || {};
                            item.hidden = rootPermissionValue && rootPermissionValue.hasOwnProperty('navigation') ? !rootPermissionValue.navigation : false;
                        }

                        if (!item.hidden) {
                            // 属于左侧导航
                            if (item.children.length) {
                                if (item.meta && item.meta.open) {
                                    opendsNav.push(item.name)
                                }
                                // 判断二级导航
                                let childs = 0;
                                let tips = 0;
                                item.children.forEach(child => {
                                    if (child.meta && child.meta.role) {
                                        const permissionValue = permission[child.meta.role] || {};
                                        // 提示逻辑
                                        if (permissionValue.tips) {
                                            child.meta.tipsIcon = 'icon_tips';
                                            child.meta.tips = permissionValue.tips;
                                            tips ++;
                                        } else {
                                            child.meta.tipsIcon = '';
                                            child.meta.tips = '';
                                        }
                                        // 需要通过权限控制是否显示
                                        if (permissionValue.navigation) {
                                            childs ++
                                            child.hidden = false
                                        } else {
                                            child.hidden = true
                                        }
                                    } else {
                                        childs ++
                                        // 兼容无权限二级导航，前端固定配置提示的情况
                                        if (child.meta && child.meta.tips) {
                                            child.meta.tipsIcon = 'icon_tips';
                                            tips++;

                                            // 新功能上线提示三个月（2023.04.10 22:00:00 过期隐藏）1681135200000
                                            if (child.meta.tipsDeadLine) {
                                                const now = new Date().getTime();
                                                const expiration = child.meta.tipsDeadLine;
                                                const showCount = localStorage.getItem(`show${child.name}`);
                                                // 未过期
                                                if (now < expiration) {
                                                    if (showCount > 0) {
                                                        child.meta.tipsIcon = '';
                                                        tips--;
                                                    }
                                                } else {
                                                    // 已过期
                                                    child.meta.tipsIcon = '';
                                                    tips--;
                                                }
                                            }
                                        }
                                    }
                                })
                                // 根据二级导航提示数量为一级导航增加红点提示
                                if (tips > 0) {
                                    item.meta.tipsIcon = 'red_point';
                                } else {
                                    item.meta.tipsIcon = '';
                                }
                                return !!childs
                            } else if (item.meta && item.meta.role) {
                                // 需要通过权限控制是否显示
                                return permission.indexOf(item.meta.role) !== -1
                            } else {
                                return true
                            }
                        } else {
                            return false
                        }
                    }))
                    this.navDefaultOpends = opendsNav
                }).catch(e => {
                    console.log(e)
                })
                this.$store.dispatch('checkMessage');
            } else {
				// 验证失败
				this.$router.push({ path: '/login' })
            }
		},
        /** 
         * @name 20220616 资源位埋点方法 
         * @author likailiang
         * @param evtId 事件ID：曝光CCRePoEXP 点击CCRePoClK
         * */
        sa(evtId, ContentID, ContentName) {
            /** 资源位埋点：曝光CCRePoEXP 点击CCRePoClK */ 
            this.$util.doSensorsTrack(evtId, {
                OperationType: '弹窗', // 运营位类型
                ContentID: ContentID.toString(), // 投放ID
                ContentName, // 内容标题
                uid: this.uid.toString() // 用户id
            })
        }
    }
}
</script>
<style>
.alert-dialog .el-dialog {
  min-width: 424px
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
    .app-wrap {
        @include clearfix;
        position: relative;
        background: #F9F9F9;
        min-height: 100%;
    }
    .alert-info {
        .show-alert-img {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1001;
            background: rgba(0, 0, 0, 0.5);
            .content-wrap {
                position: absolute;
                width: 720px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                // margin-left: -360px;
                text-align: center;
                .close {
                    width: 32px;
                    height: 32px;
                    font-size: 32px;
                    position: absolute;
                    right: -16px;
                    top: -24px;
                    cursor: pointer;
                }
                .image {
                  width: 100%;
                  height: 405px;
                  margin-bottom: 24px;
                  cursor: pointer;
                }
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>
